import React, { useState, useEffect } from 'react';

// Amplify
import { API, graphqlOperation } from 'aws-amplify';

// Components
import { Button, Table } from 'antd';

// Mock
// import AddItem from './AddItem';
// import EditItem from './EditItem';
import { activitiesByTimesheet, listTimesheets, timesheetsByContractor } from '../../graphql/queries';
import { Link } from 'react-router-dom';
import { History } from 'history';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import { ContractorActivity, TimesheetStatus } from '../../API';
import ActivityModalForm from './ActivityModalForm';
import { Timesheet } from '../../types';
import { ApiInfiniteTable } from 'basealpha-ui';
import { getQueryParameters } from '../../utils/query';

class ActivityTable extends ApiInfiniteTable<ContractorActivity> {}

type Props = IAppStateComponentProps & { timesheetId: string; timesheet?: Timesheet };
const List = (props: Props): React.ReactElement => {
  const [selectedRecord, setSelectedRecord] = useState<ContractorActivity | undefined>(undefined);
  const dataSource = async (page: number | null, pageSize?: number): Promise<{ data: ContractorActivity[]; count: number }> => {
    const params = getQueryParameters();
    return await API.get('EhcmsPortalApi', `/timesheet-review/${props.timesheetId}/activities`, {
      queryStringParameters: {
        token: params.token,
      },
    });
  };

  const refreshTable = () => {
    const event = new Event('refresh#contractor-activity-table');
    window.dispatchEvent(event);
  };

  const closeModal = () => {
    setSelectedRecord(undefined);
  };

  // description
  // assignedBy
  // team
  // status
  // startDate
  // endDate
  // document
  const columns = [
    {
      title: 'Task',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Assigned By',
      dataIndex: 'assignedBy',
      key: 'assignedBy',
    },
    {
      title: 'Team',
      dataIndex: 'team',
      key: 'team',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: 'Expected / Completion Date',
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: 'Link to the document in the archiving folder',
      dataIndex: 'document',
      key: 'document',
    },
  ];
  const isLocked = props.timesheet?.submitted && props.timesheet?.status !== TimesheetStatus.REJECTED;
  return (
    <React.Fragment>
      <br />
      <ActivityTable
        tableId="contractor-activity-table"
        onRowClick={(record: ContractorActivity, rowIndex: number): void => {
          setSelectedRecord(record);
        }}
        columns={columns}
        dataFetcher={dataSource}
      />
      <ActivityModalForm
        record={selectedRecord}
        timesheetId={props.timesheetId}
        onSave={refreshTable}
        close={closeModal}
        showModal={typeof selectedRecord !== 'undefined'}
      />
    </React.Fragment>
  );
};

export default withAppState(List);
